module.exports = __webpack_public_path__ + "static/media/browser-window-03.3d83c3eb.png";